export const QUERY_PARAM_TEXT = 'text' as const;
export const QUERY_PARAM_ASSIGNEE = 'assignee' as const;
export const QUERY_PARAM_LABEL = 'label' as const;
export const QUERY_PARAM_SELECTED_ISSUE = 'selectedIssue' as const;
export const QUERY_PARAM_ISSUE_PARENT = 'issueParent' as const;
export const QUERY_PARAM_ISSUE_PARENT_PANEL = 'issueParentPanel' as const;
export const QUERY_PARAM_VERSION_PANEL = 'versionPanel' as const;
export const QUERY_PARAM_ISSUE_TYPE = 'issueType' as const;
export const QUERY_PARAM_VERSION = 'version' as const;
export const QUERY_PARAM_CUSTOM_FILTER = 'customFilter' as const;
export const QUERY_PARAM_IS_INSIGHTS_OPEN = 'isInsightsOpen' as const;
export const QUERY_PARAM_EPICS = 'epics' as const;
export const QUERY_PARAM_VERSIONS = 'versions' as const;
